class ImagePlaceholder {
  constructor() {
    this.settings = {
      img: 'img',
    };
  }

  init() {
    const images = $(this.settings.img);
    images.on({
      error(e) {
        e.preventDefault();
        $(this).attr('src', window.placeholderImg);
      },
    });
    images.each((index) => {
      const $img = $(images[index]);
      if ($img.attr('src') === '') {
        $img.attr('src', window.placeholderImg);
      }
    });
  }
}

export default ImagePlaceholder;
